/**
 *
 * @module subscriptionProvider
 * @see https://github.com/STRML/keyMirror
 *
 */

/* eslint new-cap: 'off' */

import KeyMirror from 'keymirror';

/**
 *
 * @typedef SubscriptionProvider
 * @type {Object}
 * @desc Defines the providers of subscriptions.
 *
 * @property {String} BAMTECH - The subscription was initiated through BAMTECH.
 * @property {String} APPLE - The subscription was initiated through Apple.
 * @property {String} GOOGLE - The subscription was initiated through Google.
 * @property {String} ROKU - The subscription was initiated through Roku.
 * @property {String} SAMSUNG - The subscription was initiated through Samsung.
 * @property {String} OTHER
 *
 */

/**
 *
 * @enum
 * @type {SubscriptionProvider}
 *
 */
export default KeyMirror({
    /**
     *
     * @access public
     * @type {String}
     *
     */
    BAMTECH: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    APPLE: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    GOOGLE: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    ROKU: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    SAMSUNG: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    OTHER: null
});



// WEBPACK FOOTER //
// ./src/subscription/subscriptionProvider.js